import { styled } from '@mui/material/styles';
import { DialogContent, DialogActions, Button } from '@mui/material';

// Dialog content with minimum width and padding
export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  minWidth: 300,
  padding: theme.spacing(2),
}));

// Dialog actions with padding
export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2),
}));

// Destructive action button (red)
export const DestructiveButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.error.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

// Cancel button with right margin
export const CancelButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
})); 